export var MODAL_STANDARD_MAX_WIDTH = 656;
export var MODAL_SMALL_MAX_WIDTH = 448;
export var MODAL_EXTRA_SMALL_MAX_WIDTH = 335;